import React from 'react';
import {
  ConversationSummary, ConversationType,
} from '@marageti/z4-sdk/lib/travel';
import CardLink from './CardLink';
import {
  getConversationIcon,
  getConversationTypeTitle,
} from './helpers';
import ConversationParticipantNames from '../conversation-participant-names';

export type ConversationLinkProps = {
  to?: string
  badgeColor?: 'info' | 'warning' | 'error'
  conversationSummary: ConversationSummary
  getConversationTypeTitle?: (type: ConversationType) => string | undefined
  getConversationIcon?: (type: ConversationType) => React.ReactNode | undefined
};

const ConversationLink = ({
  to = undefined,
  badgeColor,
  conversationSummary,
  getConversationTypeTitle: customGetConversationTypeTitle = undefined,
  getConversationIcon: customGetConversationIcon = undefined,
}: ConversationLinkProps) => {
  const { conversationType, hasNewMessages } = conversationSummary;
  const title = customGetConversationTypeTitle
    ? customGetConversationTypeTitle(conversationType)
    : getConversationTypeTitle({ conversationType });

  return (
    <CardLink
      to={to}
      primary={title}
      secondary={(
        <ConversationParticipantNames
          conversationId={conversationSummary.conversationId}
          typographyProps={{
            variant: 'caption',
          }}
        />
)}
      icon={customGetConversationIcon
        ? customGetConversationIcon(conversationType)
        : getConversationIcon({ conversationType })}
      showBadge={badgeColor && hasNewMessages}
      badgeColor={badgeColor}
    />
  );
};

export default ConversationLink;
